// extracted by mini-css-extract-plugin
export default {"container":"LoginModal_container__CUw8M","close":"LoginModal_close__I2ILH","content":"LoginModal_content__YX0f1","divider":"LoginModal_divider__hy0ZF"};